<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<h2 class="inline-heading">
						{{$t('global.operationAssignment')}}
						<!-- <md-icon v-b-modal.operation-explanation icon="help_outline" /> -->
						<b-modal
							id="operation-explanation"
							ok-only
							hide-footer
							size="lg"
						>
							<h2>Modulo de asignación de conductor y unidad</h2>
						</b-modal>
					</h2>
					<b-form @submit.prevent="() => updateLists() ">
						<b-row>
							<b-form-group class="col-md-3" :label="$t('bookings.servicesFrom')">
								<b-form-datepicker
									:locale="$root.store.state.currentUser.lang"
									reset-button
									size="sm"
									v-model="filters.pickupStartDate"
								/>
							</b-form-group>
							<b-form-group class="col-md-3" :label="$t('bookings.servicesTo')">
								<b-form-datepicker
									:locale="$root.store.state.currentUser.lang"
									reset-button
									size="sm"
									v-model="filters.pickupEndDate"
								/>
							</b-form-group>
							<b-form-group class="col-md-2" :label="$t('bookings.keyword')">
								<b-input v-model="filters.keyword"></b-input>
							</b-form-group>
							<b-form-group class="col-md-3" :label="$t('bookings.serviceStatus')">
								<multiselect
									:class="{'active-filter':filters.status.length>0}"
									v-model="filters.status"
									:options="statusOpts"
									group-label="group"
									group-values="options"
									group-select
									multiple
									label="text"
									track-by="value"
									:placeholder="$t('global.all')"
									taggable
								/>
							</b-form-group>
							<b-form-group class="col-md-1 pt-3">
								<b-button type="submit" variant="primary" >{{$t('global.search')}}</b-button>
							</b-form-group>
						</b-row>
						<b-button @click="showFilters = !showFilters" variant="info" >{{$t('global.filters')}}</b-button>
						<template v-if="showFilters">
							<hr>
							<b-row>
								<b-form-group class="col-md-2" label="Res ID">
									<b-form-input size="sm" :class="{'active-filter':filters.id}" v-model="filters.id" type="number" />
								</b-form-group>
								<b-form-group class="col-md-2" :label="$t('bookings.clientName')">
									<b-form-input size="sm" :class="{'active-filter':filters.clientFullName}" v-model="filters.clientFullName" type="text" />
								</b-form-group>
								<b-form-group class="col-md-3" :label="$t('bookings.airports')">
									<multiselect
										:class="{'active-filter':filters.airport.length>0}"
										v-model="filters.airport"
										:options="airportsOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										:placeholder="$t('global.all')"
										:option-height="10"
										taggable
									/>
								</b-form-group>
								<b-form-group class="col-md-3" :label="$t('bookings.destinations')">
									<multiselect
										:class="{'active-filter':filters.destination.length>0}"
										v-model="filters.destination"
										:options="destinationsOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										:placeholder="$t('global.all')"
										taggable
									/>
								</b-form-group>
								<b-form-group class="col-md-2" :label="$t('saleChannel.saleChannel')">
									<SelectSaleChannel v-model="filters.salesChannels"></SelectSaleChannel>
								</b-form-group>
							</b-row>
							<b-row>
								<b-form-group class="col-md-2" :label="$t('bookings.salesReference')">
									<b-form-input size="sm" :class="{'active-filter':filters.salesChannelReference}" v-model="filters.salesChannelReference" type="text" />
								</b-form-group>
								<b-form-group class="col-md-3" :label="$t('bookings.serviceType')">
									<multiselect
										:class="{'active-filter':filters.serviceType.length>0}"
										v-model="filters.serviceType"
										:options="serviceTypesOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										:placeholder="$t('global.all')"
										taggable
									/>
								</b-form-group>
								<b-form-group class="col-md-2" :label="$t('bookings.pickupConfirmed')">
									<b-form-select :class="{'active-filter':filters.pickupDatetimeConfirmed}" size="sm" v-model="filters.pickupDatetimeConfirmed" :options="pickupConfirmedOpts" />
								</b-form-group>
								<b-form-group class="col-md-2" :label="$t('bookings.trackingStatus')">
									<b-form-select :class="{'active-filter':filters.trackingStatus}" size="sm" v-model="filters.trackingStatus" :options="trackingStatusOpts" />
								</b-form-group>
								<b-form-group class="col-md-2" :label="$t('bookings.tripType')">
									<b-form-select :class="{'active-filter':filters.trip}" size="sm" v-model="filters.trip" :options="tripOpts" />
								</b-form-group>
							</b-row>
							<b-row >
								<b-form-group class="col-md-12 text-right mt-2" >
									<b-button class="btn-middle" @click="filters = {...defaultFilters}; updateLists() " variant="info" >{{$t('global.clean')}}</b-button>
									<b-button type="submit" variant="primary" >{{$t('global.search')}}</b-button>
								</b-form-group>
							</b-row>
						</template>
						<hr>
						
					</b-form>
					<b-row>
						<b-col>
							<h5>
								<b-badge
									v-for="(aux,i) in $root.auxVars.transportServiceStatusOpts"
									:key="i"
									:variant="aux.class"
									class="mr-2"
									size=""
									>
									{{$t(`bookings.serviceStatusOpts.${aux.value}`)}}
								</b-badge>
							</h5>
						</b-col>
					</b-row>
					<br>
					<h3>{{$t('bookings.unassignedServices')}}</h3>
					<AjaxTableReservations
						id="reservations-index-list"
						stacked="lg"
						show-select-all
						hide-pagination
						:selected-items.sync="itemsAssigned"
						:filters="filtersCleanNotAssigned"
						:columns="filteredColumns"
						:itemsFilter="itemsFilter"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						resource="transport-services"
						responsive
						:res-view="resView"
					/>
					<div class="text-right">
						<b-button variant="primary" @click="showAssignDriverUnit = false" v-b-toggle.sidebar-assignation>{{$t('bookings.assignDriverUnit')}}</b-button>
					</div>
					<h3>{{$t('bookings.assignedServices')}}</h3>
					<AjaxTableReservations
						id="reservations-index-list2"
						stacked="lg"
						show-select-all
						hide-pagination
						:selected-items.sync="itemsAssigned"
						:filters="filtersCleanAssigned"
						:columns="filteredColumns"
						:itemsFilter="itemsFilter"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						resource="transport-services"
						responsive
						:res-view="resView"
					/>

					<div class="text-right">
						<b-button variant="primary" @click="showAssignDriverUnit = false" v-b-toggle.sidebar-assignation>{{$t('bookings.assignDriverUnit')}}</b-button>
					</div>
				</div>
			</div>
			<AssignDriverUnit :selected="itemsAssigned" :show.sync="showAssignDriverUnit" @onUpdate="updateLists()"/>
			<Single
				ref="single"
				:model-id.sync="modelId"
				:show.sync="showSingleModal"
				@onCopyRes="copyCurrentRes"
				operated-by="supplier"
			/>
			<vue-snotify></vue-snotify>
			<b-sidebar id="sidebar-assignation" sidebar-class="sidebar-assignation" :title="$t('assignation.operation')" bg-variant="light" shadow right>
				<DriverAssignmentModule :ridesSelected="itemsAssigned"  @onUpdate="updateLists()"/>
			</b-sidebar>
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import Multiselect from 'vue-multiselect'
import Single from './Single'
import AssignDriverUnit from './AssignDriverUnit'
import AjaxTableReservations from './AjaxTableReservations'
import SelectSaleChannel from '../../helpers/SaleChannelSelect.vue';
import DriverAssignmentModule from './../assignation/DriverAssignment.vue';

export default {
		components: { MainLayout, Multiselect, Single, AssignDriverUnit, AjaxTableReservations, SelectSaleChannel,DriverAssignmentModule},
		data(){
			const now = this.$moment().format("YYYY-MM-DD")
			// const now = '2020-01-05'
			let defaultFilters = {
				id:'',
				clientFullName:'',
				destination:[],
				airport:[],
				serviceType:[],
				pickupStartDate : now,
				pickupEndDate : now,
				creationStartDate:'',
				creationEndDate:'',
				cancelationStartDate:'',
				cancelationEndDate:'',
				pickupDatetimeConfirmed:null,
				trackingStatus:null,
				trip:0,
				status:[{value:'active',text:this.$t(`bookings.serviceStatusOpts.active`)}],
				salesChannelReference: '',
				supplierReference: '',
				supplierConfirmation:'accepted',
				salesChannelTitle:'',
				salesChannels:[],
				keyword:''
			}
			return {
				showAssignDriverUnit:false,
				itemsAssigned:[],
				showFilters:false,
				modelId:-1,
				showSingleModal:false,
				exportLoading:false,
				showSelectAll:true,
				sortBy: 'reservationId',
				sortDesc: true,
				filters : {...defaultFilters},
				defaultFilters : {...defaultFilters},
				modelColumns : [
					{key:'reservationId',label:'Res ID', tdClass:'one-line-fix'},
					{key:'internalReference',label:this.$t("bookings.internalReference"), tdClass:'one-line-fix'},
					{key:'clientName',label: this.$t('bookings.client')},
					{key:'pickup',label:'Pickup'},
					{key:'dropoff',label:'Dropoff'},
					{key:'trip',label:this.$t('bookings.trip')},
					{key:'pickupDatetime',label: this.$t('bookings.pickupDatetime'),sortable:true, tdClass:'one-line-fix'},
					{key:'userDriver',label:this.$t('bookings.driver')},
					{key:'transportUnit',label:this.$t('bookings.transportUnit')},
					{key:'supplierServiceType.name',label:this.$t('bookings.serviceType')},
					{key:'trackingStatus',label:this.$t('bookings.trackingStatus')},
					{key:'actions',label:this.$t('bookings.actions')},
					// {key:'save',label:this.$t('global.save')},
				],
			}
		},
		computed: {
			pickupConfirmedOpts(){
				// eslint-disable-next-line
				this.$root.$i18n.locale
				return [
					{value:null,text:this.$t('global.all')},
					{value:true,text:this.$t('bookings.confirmed')},
					{value:false,text:this.$t('bookings.noConfirmed')}
				]
			},
			trackingStatusOpts(){
				// eslint-disable-next-line
				this.$root.$i18n.locale
				return [
					{value:null,text:this.$t('global.all')},
					{value:'pending',text:this.$t('bookings.trackingStatusOpts.pending')},
					{value:'onWayToPickup',text:this.$t('bookings.trackingStatusOpts.onWayToPickup')},
					{value:'atPickup',text:this.$t('bookings.trackingStatusOpts.atPickup')},
					{value:'onWayToDropoff',text:this.$t('bookings.trackingStatusOpts.onWayToDropoff')},
					{value:'finished',text:this.$t('bookings.trackingStatusOpts.finished')},
					{value:'noShow',text:this.$t('bookings.trackingStatusOpts.noShow')},
				]
			},
			filteredColumns(){
				let aux = [];
				if (this.showSelectAll) {
					aux.push({key:'selected',label:''});
				}
				aux = aux.concat(this.modelColumns);
				return aux;
			},
			filtersCleanAssigned(){
				return {
					id:  this.filters.id,
					clientFullName:  this.filters.clientFullName,
					destination:  this.filters.destination.map(aux => aux.value),
					airport:  this.filters.airport.map(aux => aux.value),
					serviceType:  this.filters.serviceType.map(aux => aux.value),
					pickupStartDate: this.filters.pickupStartDate,
					pickupEndDate: this.filters.pickupEndDate,
					creationStartDate: this.filters.creationStartDate,
					creationEndDate: this.filters.creationEndDate,
					cancelationStartDate: this.filters.cancelationStartDate,
					cancelationEndDate: this.filters.cancelationEndDate,
					trip: this.filters.trip,
					status: this.filters.status.map(aux => aux.value),
					salesChannelReference: this.filters.salesChannelReference,
					pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
					trackingStatus: this.filters.trackingStatus,
					supplierReference: this.filters.supplierReference,
					driverAssigned: true,
					salesChannelTitle:this.filters.salesChannelTitle,
					salesChannels:this.filters.salesChannels,
					keyword:this.filters.keyword
				}
			},
			filtersCleanNotAssigned(){
				return {
					id:  this.filters.id,
					clientFullName:  this.filters.clientFullName,
					destination:  this.filters.destination.map(aux => aux.value),
					airport:  this.filters.airport.map(aux => aux.value),
					serviceType:  this.filters.serviceType.map(aux => aux.value),
					pickupStartDate: this.filters.pickupStartDate,
					pickupEndDate: this.filters.pickupEndDate,
					creationStartDate: this.filters.creationStartDate,
					creationEndDate: this.filters.creationEndDate,
					cancelationStartDate: this.filters.cancelationStartDate,
					cancelationEndDate: this.filters.cancelationEndDate,
					trip: this.filters.trip,
					status: this.filters.status.map(aux => aux.value),
					salesChannelReference: this.filters.salesChannelReference,
					trackingStatus: this.filters.trackingStatus,
					pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
					supplierReference: this.filters.supplierReference,
					driverAssigned: false,
					salesChannelTitle:this.filters.salesChannelTitle,
					salesChannels:this.filters.salesChannels,
					keyword:this.filters.keyword
				}
			},
			destinationsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.destinationsOpts}]
			},
			airportsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.airportsOpts}]
			},
			statusOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.transportServiceStatusOpts.map(opt => ({value:opt.value,text:this.$t(`bookings.serviceStatusOpts.${opt.value}`)}))}]
			},
			tripOpts(){
				let aux = [...this.$root.auxVars.tripOpts]
				aux.unshift({value:0,text: this.$t('global.all')})
				return aux
			},
			serviceTypesOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.serviceTypesOpts}]
			},
			statusLabels(){
				let vars = this.$root.auxVars.transportServiceStatusOpts
				let opts = {}
				for (let i = 0; i < vars.length; i++) {
					opts[vars[i].value] = vars[i].text
				}
				return opts
			},
			serviceStatusVariants(){
				let aux = {}
				this.$root.auxVars.transportServiceStatusOpts.map(status => {
					aux[status.value] = status.class
				})
				return aux
			},
		},
		methods:{
			copyCurrentRes(){
				const aux = this.modelId
				this.modelId = -1
				this.$refs.single.copyFromId(aux)
			},
			updateLists(){
				this.itemsAssigned = []
				this.$root.$emit('bv::refresh::table', 'reservations-index-list')
				this.$root.$emit('bv::refresh::table', 'reservations-index-list2')
			},
			itemsFilter(items){
				return items.map(item => ({
					...item,
					// userDriverInput : item.userDriver !== null ? { value:item.userDriver.id, text: `${item.userDriver.firstName} ${item.userDriver.lastName}` } : {value:null,text:"N/A"},
					// transportUnitInput: item.transportUnit !== null ? { value:item.transportUnit.id, text: item.transportUnit.title } : {value:null,text:"N/A"},
					// loading: false ,
					_rowVariant : this.serviceStatusVariants[item.status]
				}));
			},
			resView(item){
				this.modelId = item.reservationId
				this.showSingleModal = true
			},
		},
		mounted(){
			this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ['serviceTypesOpts','airportsOpts','destinationsOpts']});
		},
		watch:{
		}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style >
	.multiselect__tags{
		max-height: 150px;
		overflow-y: auto;
		overflow-y: auto;
	}
	.active-filter{
		border: 2px solid #021D3E;
	}
	.snotifyToast__title {
		font-size: 1.5em;
	}
	.inline-heading {
		display: inline;
	}
	.inline-button {
		margin-bottom: 10px;
	}
	.btn-middle {
		margin-right: 8px;
	}
	
	
</style>
<style scoped>

</style>
